










































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  SurveyItem,
  RadioItemValue,
  OptionTextArea
} from "@/models/SurveyItem";
import { ValidationProvider } from "vee-validate";

@Component({
  components: {
    ValidationProvider
  }
})
export default class RadioItem extends Vue {
  @Prop({ type: Object })
  item!: SurveyItem;

  @Prop({
    type: Object,
    default: () => {
      return new RadioItemValue("");
    }
  })
  value!: RadioItemValue;

  @Prop({ type: Number, default: 0 })
  langValue!: number;

  localValue!: RadioItemValue;
  localText!: OptionTextArea[];
  radioRules = { required: false, max: 10, radioOptionTextArea: "" };
  previouslySelected = "";
  isImmidiate = false;

  created() {
    this.radioRules = { ...this.radioRules, ...this.item.rules };
    if (this.value.selected.length === 0) {
      this.loadLocalValue();
      this.emitLocalValue();
    } else {
      this.localValue = this.value;
    }
    const ids = this.getOptionIdWithTextArea();
    this.loadLocalText(ids);
    this.loadPreviouslySelected();
    this.updateRadioRules();
  }

  getLocalText(id: string) {
    return this.localText.find(v => v.id === id)?.text ?? "";
  }

  getOptionIdWithTextArea() {
    return this.item.options.filter(v => v.isTextArea).map(v => v.id);
  }

  isDisabled(id: string) {
    return id !== this.localValue.selected;
  }

  loadLocalValue() {
    try {
      this.localValue = JSON.parse(
        localStorage.getItem(this.item.id) ?? ""
      ) as RadioItemValue;
    } catch (e) {
      this.localValue = new RadioItemValue("");
    }
  }

  loadLocalText(ids: string[]) {
    this.localText = [];
    ids.forEach(id => {
      const text = localStorage.getItem(this.item.id + id) ?? "";
      this.localText.push(new OptionTextArea(id, text));
    });
  }

  loadPreviouslySelected() {
    this.previouslySelected =
      localStorage.getItem(this.item.id + "__PreviouslySelected__") ?? "";
  }

  saveLocalValue() {
    localStorage.setItem(this.item.id, JSON.stringify(this.localValue));
  }

  saveLocalText() {
    this.localText.forEach(v => {
      localStorage.setItem(this.item.id + v.id, v.text);
    });
  }

  savePreviouslySelected() {
    localStorage.setItem(
      this.item.id + "__PreviouslySelected__",
      this.previouslySelected
    );
  }

  emitLocalValue() {
    this.$emit("input", this.localValue);
  }

  async validate() {
    type ValidationProviderRef = InstanceType<typeof ValidationProvider>;
    await (this.$refs.validationProvider as ValidationProviderRef).validate();
  }

  updateRadioRules() {
    // 右辺の値をvalidation.tsのoptionTextArea内にあるvalidate関数に引数として与える
    // 引数によってTextAreaを持つラジオボタン選択時の入力チェックを実施
    this.radioRules.radioOptionTextArea = JSON.stringify(this.localValue);
  }

  updateValue(value: string) {
    this.localValue = new RadioItemValue(value);
    this.localText.forEach(v => {
      if (v.id === value) {
        this.localValue.optionTextArea = new OptionTextArea(v.id, v.text);
      }
    });
    this.saveLocalValue();
    this.emitLocalValue();
    this.updateRadioRules();
  }

  updateText(id: string, text: string) {
    this.localText.filter(v => v.id === id).forEach(v => (v.text = text));
    this.saveLocalText();
    this.localValue.optionTextArea = new OptionTextArea(id, text);
    this.saveLocalValue();
    this.emitLocalValue();
    this.updateRadioRules();
    this.validate();
  }

  clearRadioButton(value: string) {
    if (value === this.previouslySelected) {
      if (!this.isImmidiate) {
        // ライブラリであるvee-validationの不具合対策
        // 再ロード直後にラジオボタンをクリアした際、入力チェックを実施するのための対策
        this.isImmidiate = true;
      }
      this.previouslySelected = "";
      this.localValue = new RadioItemValue("");
      this.saveLocalValue();
      this.emitLocalValue();
      this.updateRadioRules();
    } else {
      this.previouslySelected = value;
    }
    this.savePreviouslySelected();
  }
}
